export default __webpack_public_path__ + "static/media/S_Sol.2967d1b9.svg";